.container {
  display: flex;
  align-items: flex-start;
  min-height: calc(100vh - 52px);
}

.sidebarWrapper {
  padding: 20px 10px 0 20px;
  width: 200px;
  background-color: var(--white-alt);
  min-height: calc(100vh - 52px);
}

.logo {
  height: 42px;
  margin: 6px 10px 0 10px;
}

.logoLimbic {
  margin-left: 6px;
  max-height: 1.1rem;
}

.navbarTitle {
  font-size: 1.3rem;
  font-weight: 500;
  color: var(--gray-darkest);
}

.navbarTitle:hover {
  color: var(--gray-darkest);
}
